module.exports = __webpack_public_path__ + "media/bell.bda178e0.ogg";